export interface ITooltip {
  id: string;
  message: string;
}

export enum KeyType {
  Enter = 'Enter',
}

export type TDataFeedFormValues = {
  endpointUrl: string;
  endpointUsername: string;
  endpointPassword: string;
  isDataFeedEnabled: boolean;
  createdDate: string;
  lastUpdatedDate: string;
  selectedAreas: Array<string>;
};
